// @ts-check
/** Admin CRUD for sales events (pop-ups and similar places staff sell in person). */

import api from '../utils/apiClient';

/**
 * @typedef {Object} SalesEvent
 * @property {string} id
 * @property {string} name
 * @property {string | null} venue
 * @property {string} country_code ISO-2 country the event is in (e.g. IN, US); seeds phone country for leads and sales
 * @property {string | null} state place of supply for a piece handed over here, for the GST invoice
 * @property {string} starts_on YYYY-MM-DD
 * @property {string | null} ends_on YYYY-MM-DD, null for a one-day event
 * @property {string | null} notes
 * @property {boolean} is_active
 * @property {number} sale_count
 */

const adminSalesEventService = {
  /**
   * @param {{includeArchived?: boolean}} [params]
   * @returns {Promise<SalesEvent[]>}
   */
  async list({ includeArchived = false } = {}) {
    return api.get(`/api/admin/sales-events?include_archived=${includeArchived}`);
  },

  /**
   * @param {{name: string, country_code: string, venue?: string | null, starts_on: string, ends_on?: string | null, notes?: string | null}} data
   * @returns {Promise<SalesEvent>}
   */
  async create(data) {
    return api.post('/api/admin/sales-events', data);
  },

  /**
   * Only the fields sent change. Send ends_on: null to clear the end date.
   * @param {string} id
   * @param {Partial<SalesEvent>} data
   * @returns {Promise<SalesEvent>}
   */
  async update(id, data) {
    return api.put(`/api/admin/sales-events/${id}`, data);
  },

  /** Refused by the server (409) once the event has sales; archive it instead. */
  async remove(id) {
    return api.del(`/api/admin/sales-events/${id}`);
  },
};

export default adminSalesEventService;
